import ModalAlert from "./ModalAlert";
import VueMyModal from "./VueMyModal.vue";
import ModalForm from "./ModalForm";

export { ModalAlert, ModalForm, VueMyModal };
